import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ResizerService} from "../../../commons/services/resizer.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ExportType} from "../../../commons/types/export.type";
import {RouteExportRowType} from "../../../routes/enums/route-export-row.type";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {ChangeRouteResourceQueryModelModel} from "../../../routes/models/change-route-resource-query-model.model";

export class PlanningRoutesCtrl implements IController {
  ids: string[];
  project: any;
  from: any;
  to: any;
  statuses: any;
  areaIds: any;
  agentIds: any;
  resourceIds: any;
  branchIds: any;
  branchMode: any;
  selectedGroup: any;

  public serviceAreasRef: any;
  public siteId: any;
  public tasksRef: any;
  public loading: boolean = false;
  public timelineZoom: any = undefined;
  public routesMenu: any = {
    deleteEnabled: true,
    resetEnabled: true
  };
  public totals: any = undefined;
  public totalSelectedRoutesCount: any = undefined;
  public expandedRoutes: any = [];
  public suggestedServices: any = [];
  public selectedIds: any = [];
  public excludeMode: boolean = false;
  public routeGroupKeys: any;
  public expendedRoutesServiceAreas: any = [];
  public filterConfig: any;
  public isMouseHorizontalDown: boolean = false;
  public isMouseVerticalDown: boolean = false;
  public showMap: boolean = false;
  public isMobile: boolean;
  public flexLeft: any;
  public flexRight: any;
  public selectedTaskId: any;
  public timeSelectEnabled: any;
  private routesRef: any;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private routesService: RoutesService,
              private leanPlanningRequestsService: LeanPlanningRequestsService, private routeRequestsService: RouteRequestsService, private splitService,
              private TimelineService, private resizerService: ResizerService, private tasksService: TasksService,
              private leanPlanningConstants, private moment, private branchesDialogService: BranchesDialogService,
              private leanPlanningAlertsService: LeanPlanningAlertsService, private $log, private confirmDialogService: ConfirmDialogService, private leanPlanningDialogService: LeanPlanningDialogService,
              private $serviceArea, private $task,
              private leanPlanningService: LeanPlanningService,
              private $mdMedia,
              private $planningRoutes,
              private commonsConstants,
              private commonsDialogService: CommonsDialogService) {
    this.serviceAreasRef = this.$serviceArea();
    this.siteId = this.splitService.getSiteId();
    this.tasksRef = this.$task();
    this.routeGroupKeys = this.leanPlanningConstants.routeGroupKeys;

  }

  $onInit() {
    this.filterConfig = {
      routeIds: this.ids,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      queryString: undefined,
      statuses: this.statuses || [],
      branchIds: this.branchIds || [],
      serviceAreaIds: this.areaIds || [],
      agentIds: this.agentIds || [],
      resourceIds: this.resourceIds || [],
      range: {dateStart: undefined, dateEnd: undefined},
      tags: this.project ? [this.project.id] : undefined,
      settings: this.splitService.getSitePlanningRoutesSettings()
    }

    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;

    this.showMap = false;
    // this.isMobile = !$mdMedia('gt-sm');
    // this.flexLeft = $mdMedia('gt-sm') ? '65%' : '100%';
    // this.flexRight = $mdMedia('gt-sm') ? '35%' : '100%';

    var range = (this.from && this.to) ?
      {dateStart: this.from, dateEnd: this.to} :
      (this.project ? undefined : this.dateRangeTimeFiltersService.today());

    if (!!range) {
      this._setRange(range);
      this._updateStateParams();
    }

    this._setTotals();
    this.routesRef = this.$planningRoutes();
  };

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
    this.flexLeft = this.$mdMedia('gt-sm') ? '65%' : '100%';
    this.flexRight = this.$mdMedia('gt-sm') ? '35%' : '100%';
  };


  onDividerMove(event) {
    if (this.isMouseHorizontalDown) {
      this.resizerService.onHorizontalMove(event)
        .then((flex) => {
          this.flexLeft = flex.left;
          this.flexRight = flex.right;
        });
    }
    // if (this.isMouseVerticalDown) {
    //   resizerService.onVerticalMove(event)
    //   .then(function (flex) {
    //
    //   });
    // }
  }

  onDividerMoveDone() {
    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;
  }

  submitQuery(query) {
    this.filterConfig.queryString = query;

    if (!!this.filterConfig.routeIds) {
      this.filterConfig.routeIds = undefined;
    }

    this._setTotals();
  }

  onFiltersSelect(statuses, branchIds, serviceAreaIds, agentIds, resourceIds) {
    this.filterConfig.statuses = statuses;
    this.filterConfig.branchIds = branchIds;
    this.filterConfig.serviceAreaIds = serviceAreaIds;
    this.filterConfig.agentIds = agentIds;
    this.filterConfig.resourceIds = resourceIds;

    if (!!this.filterConfig.routeIds) {
      this.filterConfig.routeIds = undefined;
    }

    this._setTotals();
    this._updateStateParams();
  }


  onRangeChanged(range) {
    if (range &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) ||
        !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {

      if (!!this.filterConfig.routeIds) {
        this.filterConfig.routeIds = undefined;
      }

      this._setRange(range)
      this._setTotals();
    }
  }

  onResetRoute(routeId) {
    this.confirmDialogService.confirm('Reset Route', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes([routeId], false);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onResetRoutes(ids) {
    this.confirmDialogService.confirm('Reset Routes', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes(this.selectedIds, this.excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onAssignRoutesToAttachedAgent(ids) {
    this.loading = true;
    this.routeRequestsService.assignRoutesToAttachedAgents(
      this.excludeMode ? [] : this.selectedIds,
      this.filterConfig.branchIds,
      this.excludeMode ? this.selectedIds : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd
    )
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
      })
      .finally(() => {
        this.loading = false;
        this.resetSelection();
      })
  }

  onTimelineZoom(isZoomIn) {
    this.timelineZoom = isZoomIn;
  }

  onZoomChanged() {
    this.timelineZoom = undefined;
  }

  onMoveTask(serviceId, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds) {
    const payload = this.TimelineService.getMovedTaskPayload([serviceId],
      fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);


    this.loading = true;
    this.leanPlanningRequestsService.editRoutes(payload)
      .then((updatedRoutes) => {
        const expandedRoutesCopy = angular.copy(this.expandedRoutes);
        _.forEach(updatedRoutes, (r) => {
          const expandedRouteIndex = _.findIndex(this.expandedRoutes, (exRoute: any) => {
            return r.rid === exRoute.rid;
          })
          if (expandedRouteIndex > -1) {
            expandedRoutesCopy[expandedRouteIndex] = r;
          }
        })
        this.expandedRoutes = expandedRoutesCopy;
        //Updating From Push
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error(
            'Failed to change route itinerary @planningRoute@onRouteOrderChange',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onReoptimizeRoute(routeId) {
    this.loading = true;
    this.leanPlanningRequestsService.optimizeRoute(routeId)
      .then((optimizedRoute) => {
        //Updating From Push
        this.leanPlanningAlertsService.reOptimizeSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.reOptimizeError();
          this.$log.error('Failed to Optimize route @planningRoute@onRecalcRoute', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onMergeRoutes(ids) {
    this.confirmDialogService.confirm('Merge Routes', 'Are you sure you want to merge these routes?')
      .then(() => {
        this.loading = true;
        return this.routeRequestsService.mergeRoutes(
          this.excludeMode ? [] : this.selectedIds,
          this.filterConfig.branchIds,
          this.excludeMode ? this.selectedIds : [],
          this.filterConfig.range.dateStart,
          this.filterConfig.range.dateEnd,
          this.filterConfig.agentSkills,
          this.filterConfig.queryString,
          this.filterConfig.serviceAreaIds,
          this.filterConfig.statuses,
          this.filterConfig.resourceIds.concat(this.filterConfig.bringozFilters.agentScheduleIds),
          this.filterConfig.tags
        )
      })
      .then(() => {
        this.leanPlanningAlertsService.mergeRoutesSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.mergeRoutesError();
          this.$log.error('Failed to merge routes @planningRoutes@onMergeRoutes', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onDeleteRoute(routeId, event) {
    this.confirmDialogService.confirm('Delete Route', 'Are you sure you want to delete this route?', event)
      .then(() => {
        this._deleteRoutes([routeId], false);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onChangeRouteColor(route) {
    this.commonsDialogService.selectColor(route.color, this.commonsConstants.colorPalletRoutes)
      .then((selectedColor) => {
        const updatedRoute = angular.copy(route);
        updatedRoute.color = selectedColor;
        this._updateRoute(updatedRoute);
      })
  }

  onDeleteRoutes(ids) {
    this.confirmDialogService.confirm('Delete Routes', 'Are you sure you want to delete these routes?')
      .then(() => {
        this._deleteRoutes(ids, this.excludeMode);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onUpdateBranchesRoutes(ids, event) {
    this.branchesDialogService.branchesSelect(event)
      .then((branchIds) => {
        this._updateBranchesRoutes(branchIds);
      })
  }

  onUpdateBranches(route) {
    this.branchesDialogService.branchesSelect(null, undefined, route.branchIds)
      .then((branchIds) => {
        this._updateBranchesRoute(route.id, branchIds);
      })
  }

  onUpdateIsBlockedByUser(routeId, isBlockedByUser) {
    this.leanPlanningService.editBlockedState(routeId, isBlockedByUser)
      .then((updatedRoute: any) => {
        const expandedRouteIndex = _.findIndex(this.expandedRoutes, (r: any) => {
          return r.id === updatedRoute.id;
        })
        if (expandedRouteIndex > -1) {
          const expandedRoutesCopy = angular.copy(this.expandedRoutes);
          expandedRoutesCopy[expandedRouteIndex] = updatedRoute;

          this.expandedRoutes = expandedRoutesCopy;
        }
        this.resetSelection();
      })
  }

  onTaskSelection(taskId) {
    this.selectedTaskId = taskId;
  }

  onSelectRoutesChanged(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;
  }

  onToggleShowRoute(route) {
    const mapRouteIndex = _.findIndex(this.expandedRoutes, (expendedRoute: any) => {
      return expendedRoute.rid === route.rid;
    })
    if (mapRouteIndex === -1) {
      this._addExpandedRoutes([route.rid]);
    } else {
      this._removeExpandedRoutes([route.rid]);
    }
  }

  resetSelection(ids?: any) {
    this.expandedRoutes = ids ? _.filter(this.expandedRoutes, (route) => {
      return !_.includes(ids, route.rid);
    }) : [];
    this.selectedIds = ids ? _.filter(this.selectedIds, (id) => {
      return !_.includes(ids, id);
    }) : [];
    this.expendedRoutesServiceAreas = ids ? _.filter(this.expendedRoutesServiceAreas, (serviceArea) => {
      const connectedRoute = _.find(this.expandedRoutes, (r) => {
        const areaIdList = _.get(r, 'serviceAreaIdList', []);
        return _.includes(areaIdList, serviceArea.areaId)
      })
      return !!connectedRoute;
    }) : [];
    this.excludeMode = false;
    this.selectedTaskId = undefined;
  }

  // onChangeServiceAreas(serviceAreas) {
  //   const serviceAreaIds = _.map(serviceAreas, function (serviceArea) {
  //     return serviceArea.areaId;
  //   });
  //
  //   if (!_.isEqual(serviceAreaIds,
  //     this.filterConfig.serviceAreaIds)) {
  //     this.filterConfig.serviceAreaIds = serviceAreaIds;
  //     this.$state.go('.', {areaIds: this.filterConfig.serviceAreaIds}, {reload: false, notify: false});
  //   }
  // }

  // function onShownRouteChanged(deleteIds, updateIds) {
  //   if (deleteIds && deleteIds.length) {
  //     _removeExpandedRoutes(deleteIds);
  //   }
  //   if (updateIds && updateIds.length){
  //     _addExpandedRoutes(updateIds);
  //   }
  // }

  onHandleUnpackedDeliveries(route, services, event) {
    this.leanPlanningDialogService.handleUnpackedServices(services, event)
      .then((serviceIdsToRemove) => {
        this.loading = true;
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove,
          route.rid)
      })
      .then(() => {
        this.leanPlanningAlertsService.removeUnpackedSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeUnpackedError();
          this.$log.error(
            'Failed to remove unpacked deliveries @planningRoutes@onHandleUnpackedDeliveries',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onUpdateResource(route) {
    this.leanPlanningDialogService.updateResource(route)
      .then((payload: {
        allocation: ResourceAllocationTimeWindowExtModel,
        queries: ChangeRouteResourceQueryModelModel
      }) => {
        this._reCreateRoute(route, payload.allocation, payload.queries);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onExport(type: RouteExportRowType) {
    this.routesService.exportRoutes(
      this.selectedIds,
      undefined,
      this.filterConfig.branchIds,
      this.filterConfig.serviceAreaIds,
      this.filterConfig.statuses,
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.queryString,
      undefined,
      type)
      .then((res) => {
      });
  }

  onManageAssistants(route, event?) {
    this.leanPlanningDialogService.manageAssistants(route, event)
      .then((updatedAssistants: string[]) => {
        this._assignAssistant(route.id, updatedAssistants)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }


  onUpdateLogisticsVehicle(task, route) {
    this.leanPlanningDialogService.onUpdateRouteBoundEquipment(route, _.get(route, 'branchIds'), event)
      .then((payload) => {
        const routeCopy = angular.copy(route);
        routeCopy.planningResource.mainLogisticsVehicleReference = payload.mainLogisticVehicle;
        if (payload.attachedLogisticVehicle) {
          if (!routeCopy.planningResource.attachedLogisticsVehicleReferences) {
            routeCopy.planningResource.attachedLogisticsVehicleReferences = [];
          }
          routeCopy.planningResource.attachedLogisticsVehicleReferences[0] = payload.attachedLogisticVehicle;
        }
        this._updateRoute(routeCopy);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onViewSettingsChange(settings){
    this.filterConfig.settings = settings;
    this.splitService.setSitePlanningRoutesSettings(settings);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateRoute(route) {
    this.routesService.updateRoute(route);
  }

  private _updateInternalTask(task, route) {
    this.tasksService.updateInternalTask(task);
  }

  private _reCreateRoute(route, resourceAllocation: ResourceAllocationTimeWindowExtModel, queries?: ChangeRouteResourceQueryModelModel) {
    this.leanPlanningService.recreateRoute(route.id, resourceAllocation.resourceAllocationId, resourceAllocation.id, "Allocation", resourceAllocation.id, queries)
  }

  private _updateStateParams() {
    this.$state.go('.', {
      routeIds: this.filterConfig.routeIds,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.branchIds,
      areaIds: this.filterConfig.serviceAreaIds,
      agentIds: this.filterConfig.agentIds,
      resourceIds: this.filterConfig.resourceIds,
      statuses: this.filterConfig.statuses,
    }, {reload: false, notify: false});
  }


  private _addExpandedRoutes(routeIds) {
    this._getExpandedRoutes(routeIds);
  }


  private _removeExpandedRoutes(routeIds) {
    this.expandedRoutes = _.filter(this.expandedRoutes, function (expendedRoute) {
      return !_.includes(routeIds, expendedRoute.rid)
    });
    this._setServiceAreaIds(this.expandedRoutes);
  }

  private _setServiceAreaIds(expandedRoutes) {
    const currentServiceAreaIds = _.map(this.expendedRoutesServiceAreas, 'areaId');
    const expendedRoutesServiceAreaIds = _.chain(expandedRoutes)
      .flatMap('serviceAreaIdList')
      .uniq()
      .value();

    const serviceAreaIdsToAdd = _.difference(expendedRoutesServiceAreaIds, currentServiceAreaIds);
    const serviceAreaIdsToRemove = _.difference(currentServiceAreaIds, expendedRoutesServiceAreaIds);

    if (serviceAreaIdsToRemove.length) {
      this.expendedRoutesServiceAreas = _.filter(this.expendedRoutesServiceAreas, function (s) {
        return !_.includes(serviceAreaIdsToRemove, s.areaId)
      })
    }

    if (serviceAreaIdsToAdd.length) {
      this._getServiceAreasByIds(serviceAreaIdsToAdd);
    }
  }

  private _getExpandedRoutes(routeIds) {
    this.routesService.getRoutes(routeIds, undefined, false)
      .then((expandedRoutes) => {
        const updatedExpendedRoutes = _.filter(this.expandedRoutes, (r) => {
          return !_.includes(routeIds, r.rid);
        });
        this.expandedRoutes = updatedExpendedRoutes.concat(expandedRoutes);

        this._setServiceAreaIds(this.expandedRoutes)
      })
  }

  private _getServiceAreasByIds(ids) {
    this.serviceAreasRef.$asyncValues(ids)
      .then((serviceAreas) => {
        this.expendedRoutesServiceAreas = _.uniqBy(this.expendedRoutesServiceAreas.concat(serviceAreas), 'areaId');

      })
  }

  private _setRange(range) {
    this.filterConfig.range = range;
    this._setTimeSelectModeByRange(range);
    this._updateStateParams();
  }

  private _setTimeSelectModeByRange(range) {
    const dateStart = this.moment(range.dateStart).format("MM/DD/YYYY"),
      dateEnd = this.moment(range.dateEnd).format("MM/DD/YYYY");
    // Disable TIME picker if its not the same date.
    this.timeSelectEnabled = _.isEqual(dateStart, dateEnd);
  }

  private _setTotals() {
    this.totals = undefined;
    this.routesService.getRoutesStatusesTotals(
      this.filterConfig.routeIds,
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.branchIds,
      this.filterConfig.serviceAreaIds,
      this.filterConfig.queryString,
      this.filterConfig.tags,
      this.filterConfig.agentIds,
    ).then((totals) => {
      this.totals = totals;

      this.totalSelectedRoutesCount = !!this.filterConfig.statuses.length ? _.reduce(this.filterConfig.statuses, (sum, n) => {
        return sum + (this.totals[n.toLowerCase()] || 0);
      }, 0) : this.totals.total;
    })
  }

  private _resetRoutes(ids, excludeMode) {
    this.loading = true;
    this.routeRequestsService.resetRoutes(
      excludeMode ? [] : ids,
      this.filterConfig.branchIds,
      excludeMode ? ids : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd
    )
      .then((updatedRoutes) => {
        if (updatedRoutes.length > 1) {
          this.leanPlanningAlertsService.resetManySuccess();
        } else {
          this.leanPlanningAlertsService.resetSuccess();
        }
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetManyError();
          this.$log.error('Failed to reset routes @planningRoutes@onResetRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  private _deleteRoutes(ids, excludeMode) {
    this.loading = true;
    this.routeRequestsService.deleteRoutes(
      excludeMode ? [] : ids,
      this.filterConfig.branchIds,
      excludeMode ? ids : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd
    )
      .then((deletedRoutes) => {
        if (deletedRoutes.length > 1) {
          this.leanPlanningAlertsService.deleteManySuccess();
        } else {
          this.leanPlanningAlertsService.deleteOneSuccess();
        }
        this.resetSelection(ids);
        this._setTotals();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.deleteManyError();
        this.$log.error('Failed to delete routes @planningRoutes@onDeleteRoutes', error);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _updateBranchesRoutes(branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch(
      this.excludeMode ? [] : this.selectedIds,
      branchIdsPayload,
      this.filterConfig.branchIds,
      this.excludeMode ? this.selectedIds : [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd
    )
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
        this.resetSelection();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update routes @planningRoutes@_updateBranchesRoutes',
            error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _updateBranchesRoute(id, branchIdsPayload) {
    this.loading = true;
    this.routeRequestsService.updateBranch([id], branchIdsPayload)
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update route branches @planningRoutes@_updateBranchesRoute', error);
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _assignAssistant(routeId: string, updatedAssistants: string[]) {
    this.routesService.assignAssistant(routeId, updatedAssistants)
      .then((updatedRoute) => {

      })
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutes', {
    bindings: {
      ids: '<?',
      project: '<?',
      from: '<',
      to: '<',
      statuses: '<',
      areaIds: '<',
      agentIds: '<?',
      resourceIds: '<?',
      branchIds: '<',
      branchMode: '<',
      selectedGroup: '<'
    },
    template: require('./planning-routes.html').default,
    controller: PlanningRoutesCtrl
  });
